<template>
  <b-row>
    <b-col cols="12" lg="8" offset-lg="2">
      <img :src="img" alt />
    </b-col>
  </b-row>
</template>

<script>
//const axios = require('axios');
export default {
  props: {
    img: String
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  margin-bottom: 35px;
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    margin-bottom: 20px;
  }
}
</style>